import styled from 'styled-components/macro';

export const SearchSelectMenuSeparator = styled.div`
  border: solid ${props => props.theme.colors.accent[7]};
  border-width: 1px 0 0 0;
  margin: 0 10px;
`;
